import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Box,
  Container,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from "@mui/icons-material/Delete";


import { FaDatabase, FaBrain, FaLaptopCode, FaChartBar } from "react-icons/fa";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import CommentIcon from "@mui/icons-material/Comment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlogImg1 from "../../assets/blog/blog1.jpg";
import BlogImg2 from "../../assets/blog/blog2.jpg";
import BlogImg3 from "../../assets/blog/blog3.jpg";
import BlogImg4 from "../../assets/blog/blog4.jpg";
import SnackbarComponent from "../SnackbarComponent"; 


const blogsData = [
    {
      id: 1,
      title: "Unlocking the Power of Data Science & AI",
      date: "January 10, 2025",
      description:
        "A deep dive into how AI and machine learning are reshaping industries by providing unprecedented insights and automation capabilities.",
      logo: <FaBrain size={40} />,
      likes: 12,
      image: BlogImg1,
      views: 150,
      content:
        "Artificial Intelligence (AI) and Data Science are transforming industries by enabling smarter decision-making, automating repetitive tasks, and uncovering hidden patterns in data. Companies leveraging AI-driven analytics gain a competitive edge by processing data faster and deriving actionable insights. From healthcare to finance, AI is revolutionizing how businesses operate and innovate.",
      sections: [
        {
          title: "AI's Evolution in Business",
          content:
            "AI has evolved from rule-based systems to advanced deep learning models capable of handling complex tasks. In the past decade, AI adoption has skyrocketed, with businesses using it for predictive analytics, natural language processing, and computer vision. For example, Netflix uses AI to recommend personalized content, while Amazon employs it for demand forecasting and warehouse automation.",
        },
        {
          title: "Key Challenges in AI Adoption",
          content:
            "Despite its potential, AI adoption faces several challenges. Data privacy concerns, such as GDPR compliance, are a major hurdle. Additionally, the lack of skilled professionals and the need for continuous model training pose significant barriers. Organizations must also address ethical concerns, such as bias in AI algorithms, to ensure fair and transparent decision-making.",
        },
        {
          title: "Future Trends in AI",
          content:
            "The future of AI lies in explainable AI (XAI), which aims to make AI decisions more transparent. Edge AI, where AI models run on local devices, is also gaining traction for real-time processing. Furthermore, AI-powered automation is expected to create new job roles while transforming existing ones.",
        },
      ],
      keyPoints: [
        "AI is revolutionizing decision-making across industries.",
        "Deep learning enhances predictive capabilities and accuracy.",
        "Ethical AI and explainability are critical for future adoption.",
      ],
      comments: [],
    },
    {
      id: 2,
      title: "Building Robust Data Engineering Pipelines",
      date: "February 12, 2025",
      description:
        "Learn how to design scalable and efficient data pipelines that enable real-time analytics and seamless data management.",
      logo: <FaDatabase size={40} />,
      likes: 8,
      image: BlogImg2,
      views: 120,
      content:
        "Data engineering is the backbone of modern data-driven organizations. It ensures the smooth flow of information across systems, enabling real-time analytics and decision-making. Well-designed pipelines eliminate bottlenecks, enhance data accessibility, and ensure data quality, making them essential for businesses leveraging big data.",
      sections: [
        {
          title: "Modern Data Pipeline Architecture",
          content:
            "Modern data pipelines are designed to handle massive volumes of structured and unstructured data. Technologies like Apache Kafka, Apache Spark, and cloud-based solutions (e.g., AWS Glue, Google Dataflow) enable scalable and resilient pipelines. For example, Netflix uses real-time data pipelines to process billions of events daily, ensuring seamless content delivery to users.",
        },
        {
          title: "Best Practices for ETL",
          content:
            "Extract, Transform, Load (ETL) processes are critical for data integration. Best practices include optimizing workflows to reduce latency, ensuring data quality through validation, and using incremental data loading to minimize resource usage. Tools like Apache Airflow and Talend simplify ETL orchestration and monitoring.",
        },
        {
          title: "Challenges in Data Engineering",
          content:
            "Data engineers face challenges such as data silos, inconsistent data formats, and the need for real-time processing. Addressing these challenges requires robust architecture, automation, and collaboration between data engineers and data scientists.",
        },
      ],
      keyPoints: [
        "Scalable data pipelines ensure efficiency and reliability.",
        "Real-time data processing is crucial for modern businesses.",
        "ETL optimization enhances performance and reduces costs.",
      ],
      comments: [],
    },
    {
      id: 3,
      title: "Mastering Code: From Basics to Advanced",
      date: "February 15, 2025",
      description:
        "A comprehensive guide to mastering coding skills, from fundamental concepts to advanced programming techniques.",
      logo: <FaLaptopCode size={40} />,
      likes: 10,
      image: BlogImg3,
      views: 200,
      content:
        "Coding is an essential skill in today's tech-driven world. Whether you're a beginner or an experienced developer, mastering coding techniques is crucial for building scalable and efficient software. This blog provides a step-by-step journey, covering fundamental programming logic, advanced algorithms, and best practices for clean code.",
      sections: [
        {
          title: "Introduction to Coding",
          content:
            "Programming is the process of writing instructions that a computer can execute. It forms the foundation of software development. Beginners should start with languages like Python or JavaScript, which are beginner-friendly and widely used in the industry. Understanding basic concepts like variables, loops, and functions is essential for building a strong foundation.",
        },
        {
          title: "Advanced Coding Techniques",
          content:
            "Beyond basic syntax, developers should focus on design patterns, clean code principles, and optimization strategies. For example, the Model-View-Controller (MVC) pattern is widely used in web development to separate concerns and improve maintainability. Additionally, writing unit tests and using version control systems like Git are critical for professional development.",
        },
        {
          title: "The Future of Coding",
          content:
            "The future of coding lies in low-code and no-code platforms, which enable non-developers to build applications. However, traditional coding skills remain essential for complex projects. Emerging technologies like quantum computing and AI-driven development tools are also shaping the future of programming.",
        },
      ],
      keyPoints: [
        "Coding is a valuable skill for problem-solving and innovation.",
        "Understanding data structures and algorithms is crucial for efficiency.",
        "Advanced techniques like design patterns improve software scalability.",
      ],
      comments: [],
    },
    {
      id: 4,
      title: "Transforming Business Intelligence",
      date: "January 04, 2025",
      description:
        "Explore how business intelligence is evolving with data analytics and visualization to drive smarter decision-making.",
      logo: <FaChartBar size={40} />,
      likes: 15,
      image: BlogImg4,
      views: 250,
      content:
        "Business Intelligence (BI) is no longer just about generating reports. Modern BI integrates predictive analytics, interactive dashboards, and real-time data processing to provide actionable insights. Organizations leveraging BI tools can make data-driven decisions, optimize operations, and gain a competitive edge.",
      sections: [
        {
          title: "The Role of BI in Business",
          content:
            "BI tools like Tableau, Power BI, and Looker help organizations analyze data and gain valuable insights. For example, retail companies use BI to track sales performance, while healthcare organizations use it to monitor patient outcomes. BI enables stakeholders to visualize data trends and make informed decisions.",
        },
        {
          title: "Future of Business Intelligence",
          content:
            "The future of BI involves AI-powered automation, real-time analytics, and enhanced data visualization techniques. For instance, natural language processing (NLP) allows users to query data using plain language, while augmented analytics automates insights generation. These advancements make BI more accessible and actionable for non-technical users.",
        },
        {
          title: "Challenges in BI Implementation",
          content:
            "Implementing BI solutions requires addressing challenges such as data integration, user adoption, and data governance. Organizations must ensure data accuracy, security, and accessibility to maximize the value of their BI investments.",
        },
      ],
      keyPoints: [
        "BI enhances decision-making through data visualization and analytics.",
        "AI-powered automation is transforming the future of BI.",
        "Data governance and user adoption are critical for successful BI implementation.",
      ],
      comments: [],
    },
  ];

const BlogReadMore = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [liked, setLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(0);
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false); 
  
    useEffect(() => {
      const selectedBlog = blogsData.find((blog) => blog.id === parseInt(id));
      setBlog(selectedBlog);
      if (selectedBlog) {
        const storedLiked = localStorage.getItem(`blog_${selectedBlog.id}_liked`);
        const storedLikeCount = localStorage.getItem(
          `blog_${selectedBlog.id}_likeCount`
        );
        setLiked(storedLiked === "true");
        setLikeCount(storedLikeCount ? parseInt(storedLikeCount) : selectedBlog.likes);
        setComments(selectedBlog.comments || []);
      }
    }, [id]);
  
    const handleLike = () => {
      if (!blog) return;
      const newLiked = !liked;
      const newLikeCount = newLiked ? likeCount + 1 : likeCount - 1;
      setLiked(newLiked);
      setLikeCount(newLikeCount);
      localStorage.setItem(`blog_${blog.id}_liked`, newLiked);
      localStorage.setItem(`blog_${blog.id}_likeCount`, newLikeCount);
    };
  
    const handleCommentSubmit = () => {
      if (comment.trim() === "") return;
      const newComment = {
        id: comments.length + 1,
        text: comment,
        date: new Date().toLocaleDateString(),
      };
      setComments([...comments, newComment]);
      setComment("");
    };
  
    const handleCommentDelete = (commentId) => {
      const updatedComments = comments.filter((c) => c.id !== commentId);
      setComments(updatedComments);
    };
  
    const handleShare = () => {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
            setSnackbarOpen(true);  
        });
      };

    const handleSnackbarClose = () => {
    setSnackbarOpen(false); 
    };
  
    if (!blog) {
      return <Typography variant="h6">Blog not found.</Typography>;
    }
  
    return (
      <Container
      maxWidth={false}
      sx={{
      mt: 4,
      mb: 4,
      width: "90%",
      paddingX: { xs: 2, sm: 4, md: 6, lg: 8 },
      paddingY: 10,
      marginX: "auto",
      overflowX: "hidden",
      }}
      >
      <Card
      sx={{
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: 3,
      padding: 3,
      }}
      >
      <CardContent>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
        {blog.title}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        {blog.date}
        </Typography>
        <img
        src={blog.image}
        alt={blog.title}
        style={{
        width: "100%",
        height: "auto",
        borderRadius: "8px",
        margin: "20px 0",
        }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        <IconButton onClick={handleLike} color={liked ? "error" : "default"}>
        <FavoriteIcon /> {likeCount}
        </IconButton>
        <IconButton onClick={handleShare}>
        <ShareIcon />
        </IconButton>
        <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
        <CommentIcon sx={{ mr: 1 }} /> {comments.length} Comments
        </Typography>
        <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
        <VisibilityIcon sx={{ mr: 1 }} /> {blog.views} Views
        </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 3 }} />
    
      {/* Blog Content */}
      <Typography variant="body1" paragraph>
        {blog.content}
      </Typography>
    
      {/* Sections */}
      {blog.sections && (
        <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Sections
        </Typography>
        <Grid container spacing={3}>
        {blog.sections.map((section, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Card
          sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
          boxShadow: 1,
          padding: 2,
          }}
          >
          <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
          {section.title}
          </Typography>
          <Typography variant="body1" paragraph>
          {section.content}
          </Typography>
          </Card>
        </Grid>
        ))}
        </Grid>
        </Box>
      )}
    
      {/* Key Points */}
      {blog.keyPoints && (
        <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Key Points
        </Typography>
        <Card
        sx={{
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: 1,
        padding: 2,
        }}
        >
        <List>
        {blog.keyPoints.map((point, index) => (
          <ListItem key={index}>
          <ListItemText primary={`• ${point}`} />
          </ListItem>
        ))}
        </List>
        </Card>
        </Box>
      )}
    
      {/* Comments Section */}
      <Box sx={{ mt: 2 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Comments
        </Typography>
       
        <Card
  sx={{
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: 1,
    padding: 2,
  }}
>
  {/* Comment Input Section */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Add a comment..."
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      sx={{ mb: 2 }}
    />
    <IconButton 
      onClick={handleCommentSubmit} 
      sx={{ 
        color: "black", // Set color to black
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        height: "48px", // Match the height of the TextField
        width: "48px",
        marginBottom: 2
      }}
    >
      <SendIcon />
    </IconButton>
  </Box>

  {/* Comment List Section */}
  <List>
    {comments.map((c) => (
      <ListItem
        key={c.id}
        secondaryAction={
          <IconButton 
            onClick={() => handleCommentDelete(c.id)} 
            sx={{ color: "black" }} // Set color to black
          >
            <DeleteIcon />
          </IconButton>
        }
      >
        <ListItemText primary={c.text} secondary={`Posted on ${c.date}`} />
      </ListItem>
    ))}
  </List>
</Card>

      </Box>
      </CardContent>
      </Card>
    
      <SnackbarComponent
      open={snackbarOpen}
      message="Link copied to clipboard!"
      onClose={handleSnackbarClose}
      />
      </Container>
    );
  };
  
  export default BlogReadMore;